<template lang='pug'>
  v-card.fontText(class="mx-auto" max-width="580" align-center raised )
    v-list-item(three-line)
      v-list-item-content(style="margin-left: 30px;" )
        div(class="row")
          div(class="col-7")
            h2.fontTitle(style="margin-top: 37px;" ) Transacción anulada
          div(class="col-5")
            img(
              :src="brand.logo"
              width="200"
              style="margin-right: 100px;"
            )
        v-list-item-subtitle
          v-row
            v-col(cols="4" class="font-weight-bold")
              p Nombre:
              p Rut:
              P Nombre Curso:
              p Valor Curso:
              p(v-if="transactionResult.discount !== 0") Descuento:
              p(v-if="transactionResult.discount !== 0") Total a Pagar:
            v-col(cols="8")
              p {{ transactionResult.userName }} {{ transactionResult.userLastname }}
              p {{ transactionResult.userRut }}
              p {{ transactionResult.courseName }}
              p {{ this.formatCurrency(transactionResult.initialAmount) }} CLP
              p {{ transactionResult.discount }}% ({{ formatCurrency(transactionResult.discountMount) }} CLP)
              p {{ formatCurrency(transactionResult.total) }} CLP
        v-list-item-subtitle
        p(class="font-weight-bold") Su compra ha sido anulada.
    v-card-actions
      v-btn(rounded class="white--text" :loading="loading" :disabled="loading" color="#E3C318" block @click="retryTransaction()") Reintentar
    v-card-actions
      v-btn(rounded color="grey lighten-1" dark block @click="gotToAulaTributaria()") Volver a Aula Tributaria
</template>

</template>

<script>
import appisTransbank from '../../utils/axiosInstances'
import brand from '../../utils/brand'

export default {
  props: {
    transactionResult: { required: true },
    transactionId: { required: true }
  },
  data () {
    return {
      brand,
      loading: false
    }
  },
  mounted () {
  },
  methods: {
    gotToAulaTributaria () {
      window.location.href = brand.homeUrl
    },
    formatCurrency (amount) {
      const formatAmount = new Intl.NumberFormat('es-CL', { currency: 'CLP', style: 'currency' }).format(amount)
      return formatAmount
    },
    async retryTransaction () {
      try {
        this.loading = true
        const data = {
          id: this.transactionId,
          isRetry: true
        }
        const response = await appisTransbank.post('/webpay/initTransaction', data)
        window.location.href = response.data.url
      } catch (error) {
      }
    }
  }
}
</script>

<style lang="stylus">
.fontText{
  font-family: "Montserrat"
}
.fontTitle{
  font-family: "Montserrat-SemiBold"
}
</style>
